export default "__VITE_ASSET__BHKaCUOr__"